import './i18n/i18n';
import './styles/tokens'
import { Suspense, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { store, persistor } from './store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/es'
import styled from 'styled-components'
import { ThemeProvider } from '@mui/material/styles'
import { muiTheme } from 'Components/ui/muiTheme'

const DAYJS_LOCALES = { pt: 'pt-br', en: 'en', es: 'es' }

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 0,
    },
  },
  logger: {
    log: console.log,
    warn: console.warn,
    error: () => { },
  }
})

const LocaleAwareApp = () => {
  const { i18n } = useTranslation()
  const lang = i18n.language || 'pt'

  useEffect(() => {
    dayjs.locale(DAYJS_LOCALES[lang] || 'pt-br')
  }, [lang])

  return <App />
}

const Spinner = styled.div`
  @keyframes spin { to { transform: rotate(360deg); } }
  width: 40px; height: 40px;
  border: 3px solid var(--vo-cloud);
  border-top-color: var(--color-brand);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 40px auto;
`

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <ThemeProvider theme={muiTheme}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <QueryClientProvider client={client}>
          <Router>
            <Suspense fallback={<Spinner />}>
              <LocaleAwareApp />
            </Suspense>
          </Router>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>,
)
